import { render, staticRenderFns } from "./porcentaje-grande.vue?vue&type=template&id=781016c6&scoped=true&"
import script from "./porcentaje-grande.vue?vue&type=script&lang=ts&"
export * from "./porcentaje-grande.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781016c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
